import React from 'react';
import { AnchorWithLink } from 'atoms/Anchor';
import ImageComponent from 'atoms/Image';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useSelector } from 'react-redux';

const KfcNearYouTextSectionComp = props => {
  const { showKfcCount, showMapLink, typeOfView, toggleView, kfcStoresCountText, kfcCount } = props;
  const isNearbyStoreLoading = useSelector(
    state =>
      state.storesReducer?.isNearByStoresLoading ||
      state.storesReducer?.isStoreStatusLoading ||
      state.storesReducer?.isFavoriteStoreStatusLoading,
  );

  return (
    <React.Fragment>
      <div className='kfc-near-you-section'>
        {showKfcCount ? (
          <div className='kfc-count'>{translateWithI18Next(kfcStoresCountText)?.replace('%storeCount%', kfcCount)}</div>
        ) : null}
        {showMapLink ? (
          <div className='list-map-link-section' data-testid='toggle-view-test' onClick={() => toggleView()}>
            <AnchorWithLink className='list-map-link'>
              <span>
                <ImageComponent data-testid='' srcFile={typeOfView?.imageSrc} alt={'map'} className='map-img' />
              </span>
              {translateWithI18Next(typeOfView?.text)}
            </AnchorWithLink>
          </div>
        ) : null}
      </div>
      {isNearbyStoreLoading && (
        <div className='placeholder'>
          {Array(8)
            .fill()
            .map(() => (
              <PlaceholderStoreComponent />
            ))}
        </div>
      )}
    </React.Fragment>
  );
};

const PlaceholderStoreComponent = () => (
  <div className='table store-card-container'>
    <div className='loading card-title shorter-s' />
    <div className='loading table-content' />
    <div className='loading table-content' />
  </div>
);

const KfcNearYouTextSection = React.memo(KfcNearYouTextSectionComp);
export default KfcNearYouTextSection;
